import { createSelector } from '@ngrx/store';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter } from './consumer-types.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getMenuState, (state: MenuState) => state.consumerTypes);
const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);

export const ConsumerTypesSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getValidAll
};
